import { useLocation } from 'react-router-dom';
import Button from '../shared/Button/Button';
import { ELIGIBILITY_INSTITUTE_ID, ELIGIBILITY_ROLES } from '../../helpers/eligibilityConfig';

const NO_NEW_LEAD_INSTITUTE_ID = '9d5eca4b-54f7-42a7-8794-1413e00b462e';

export default function SidebarNewLead({ ctx, mode, onNavigate = () => {} }) {
  const location = useLocation();

  if (location.pathname === '/dashboard') return null;
  if (ctx.instituteId === NO_NEW_LEAD_INSTITUTE_ID && ctx.role === 'institute_user') return null;

  const target =
    ELIGIBILITY_ROLES.includes(ctx.role) && ctx.instituteId === ELIGIBILITY_INSTITUTE_ID
      ? '/eligibility'
      : '/';

  return (
    <Button
      as="link"
      to={target}
      variant="primary"
      className={`sidebar-new-lead${mode === 'collapsed' ? ' sidebar-new-lead--collapsed' : ''}`}
      onClick={onNavigate}
    >
      {mode === 'collapsed' ? '+' : 'New Lead'}
    </Button>
  );
}
